import { CATALOG_ORDERS } from '../actionTypes';

export const fetchCatalogOrders = (action) => ({
  type: CATALOG_ORDERS.FETCH,
  payload: action.payload,
});
